import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withApollo } from 'react-apollo';
import Grid from '@material-ui/core/Grid';
import TopbarSidebarButton from './TopbarSidebarButton'
import TopbarProfile from './TopbarProfile';
// import TopbarMail from './TopbarMail';
// import TopbarNotification from './TopbarNotification';
import TopbarCart from "./TopBarCart";

class Topbar extends Component {
  state = {
    cart: false
  };

  componentDidMount () {
    if (this.props.history.location.pathname.includes('marketplace')) {
      this.setState({ cart: true })
    } else {
      this.setState({ cart: false });
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps !== this.props) {
      if (this.props.history.location.pathname.includes("marketplace")) {
        this.setState({ cart: true });
      } else {
        this.setState({ cart: false });
      }
    }
  }

  render () {
    return (
      <div className='topbar'>
        <Grid container id='topbar__wrapper'>
          <Grid item xs={12} id="topbar_left">
            <TopbarSidebarButton
              company={this.props.tenant && this.props.tenant.companyName ? this.props.tenant.companyName : ""}
            />
          </Grid>

          <Grid item xs={12} id="mid__section" >
            { this.props.tenant && this.props.tenant.logo !== null ? 
              (<a href="/app/dashboard">
                <img 
                  alt="logo" 
                  className="custom__topbar__logo"
                  src={this.props.tenant.logo}
                />
              </a>)
              :
              (<Link
                className='topbar__logo'
                to='/app/dashboard'
              />)
            }
          </Grid>

          <Grid item xs={12} id="topbar__right">
            <TopbarProfile /> 
            {this.state.cart ? <TopbarCart/> : null} 
          </Grid>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    cartItems: state.cartData.items,
    tenant: state.auth.tenant,
  }
}
export default withRouter(withApollo(connect(mapStateToProps)(Topbar)));



// WEBPACK FOOTER //
// ./src/pages/_layout/topbar/Topbar.js